import axios from "axios";
import { toast } from "react-toastify";

// Main domains that use the real API URL directly.
// Any other domain (payment gateways) use "/api" proxy to hide the real API server.
const MAIN_DOMAINS = ['paycoinz.com', 'www.paycoinz.com', 'test.paycoinz.com', 'localhost'];
const currentHost = window.location.hostname;
const isPaymentDomain = !MAIN_DOMAINS.includes(currentHost);

const API = axios.create({
  baseURL: isPaymentDomain ? '/api' : process.env.REACT_APP_API_URL,
});

// Request Interceptor to add auth token
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response Interceptor to auto-logout on 401 or custom error
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      (error.response.status === 401 ||
        error.response.data.message === "Token Invalid")
    ) {
      toast.error("Session expired. Logging out...");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      setTimeout(() => {
        window.location.href = "/login"; // Redirect to login page
      }, 1500);
    }
    return Promise.reject(error);
  }
);

export default API;
